import { GeneratorKey } from '@crm/api'

import { CascoCriteriaFields } from '../components/CascoCriteriaFields/CascoCriteriaFields'

import type { FC } from 'react'

/**
 * Maps a generator family to the component rendering its `criteria` fields.
 * Adding a family is one new fields component plus one entry here.
 *
 * Imports the component by file path rather than through the components barrel
 * to avoid a cycle: the barrel pulls in CampaignCriteriaCard, which imports
 * this registry.
 */
export const criteriaFieldsByGenerator: Partial<Record<GeneratorKey, FC>> = {
  [GeneratorKey.CASCO_CROSS_SELL]: CascoCriteriaFields
}
